import React from 'react';
import { Table as BSTable } from 'react-bootstrap';
import styles from './styles.module.css';

const Table = (props) => {
  const { children, className, ...rest } = props;

  const classes = `align-items-center rounded shadow-sm bg-white ${styles.table} ${className}`;

  return (
    <BSTable className={classes} {...rest}>
      {children}
    </BSTable>
  );
};

export default Table;
